export default __webpack_public_path__ + "static/media/icon_1_on.e4e88bd7.png";